import { Component, OnInit } from '@angular/core';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from '@services/notifications/notifications.service';
import { Models } from '@ibexfusion/models';
import { DialogService } from '@services/dialog/dialog.service';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { MessengerService } from '@services/messenger/messenger.service';
import { PackageService } from '@services/packages/package.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss',
  providers: [NotificationsService, PackageService],
  standalone: false
})
export class NotificationsComponent implements OnInit {
  public pageActions: PageAction[];
  public data: Models.Notification[];
  public currentItem: Models.Notification;
  public packageId: string;
  public pak: Models.Package;

  constructor(
    private route: ActivatedRoute, private notificationService: NotificationsService, private dialogService: DialogService, public http: HttpClient, private ms: MessengerService,
    private packageService: PackageService
  ) {
    this.packageId = this.route.snapshot.params['packageId'];
  }

  async ngOnInit() {
    this.getData();
  }

  async getData() {
    const getTime = (n: Models.Notification) => {
      if (n.sent) return new Date(n.sent).getTime();
      const [h = 0, m = 0] = n.publishStartTime?.split(':') ?? [];
      return new Date(n.publishStart).setHours(+h, +m, 0, 0);
    };
    this.pak = await this.packageService.get(this.packageId);
    let data = (await this.notificationService.find(0, 1000, { packageId: this.packageId }))?.data;
    this.data = (data || []).sort((a, b) => getTime(b) - getTime(a));
  }

  add() {
    const notification = new Models.Notification();
    notification.packageId = this.packageId;
    this.currentItem = notification;
  }

  send(item: any, event: any) {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    const options = { headers: { 'authentication': this.ms.basicMessengerService.getAuthenticationHeader() } };
    return this.http.post(environment.apiBaseURL + '/push/notification', { id: item._id }, options).toPromise();
  }

  async edit(item: any, event: any) {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    this.currentItem = item;
  }

  async remove(item: any, event: any) {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    const dialogRes = await this.dialogService.confirm('notifications.removeConfirmation', null);
    if (!dialogRes) {
      return;
    }
    await this.notificationService.remove(item._id);
  }

  getSendState(notification: any, planned = false) {
    if (!notification.sent && notification.instant) {
      return 'sofort';
    }
    let d: any = new Date(notification.sent ? notification.sent : notification.publishStart);
    const options: any = { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' };
    const format = new Intl.DateTimeFormat('de-DE', notification.sent ? { ...options, hour: '2-digit', minute: '2-digit', hour12: false } : options);
    return (format.format(d).replace(/,/, '').replace(/\s*Uhr\s*$/i, '') + `${notification.sent || !notification.publishStartTime ? '' : ' ' + notification.publishStartTime}`).replace('.', ',');
  }
}
